export default {
	status: [],
	totalStatus: 0,
	resources: [],
	resourcesForSelect: [],
};
